import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { PrintDeliveryDataEntity } from "../../../../../models/sift/json/print-model";
import { dialogActions } from "../../../../dialog/slice/dialog-slice";
import { PrintSelectFormDesignation } from "../../print-create-order-info/component/print-select-form-designation";
import { useParams } from "react-router-dom";
import { PathParams, RoutingPath } from "../../../../../routes/routing-path";
import { DeliveryAddressInfoInput } from "../../print-create-order-info/component/delivery-address-info-input";
import { localStorageActions } from "../../../../../slices/local-storage-slice";
import { printActions } from "../../../../../slices/sift/print-slice";
import { cloneDeep } from "lodash";
import { printOrderLockActions } from "../../../../../slices/lock-order-slice.print";
import { push } from "connected-react-router";
export const usePrintDelivery = () => {
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  const { 
    customerOrderId,
    deliveryStore: _deliveryStore,
    deliveryTypeInitValue,
    masterShopList,
    masterShopIdList,
    currentData,
   } = useAppSelector((state) => ({
    customerOrderId: state.common.customerOrderId,
    deliveryStore: state.orderPreparation.orderData?.lastName || '',
    deliveryTypeInitValue: state.storage.data.deliveryType,
    masterShopList: state.common.data.masterShop?.lnwMasterShop.shop?.[0].shopData,
    masterShopIdList: state.common.masterShopIdList,
    currentData: state.print.printShopOrderData[shopOrderId],
  }));
  const dispatch = useAppDispatch();
  const [deliveryType, setDeliveryType] = useState<'store' | 'private'>((deliveryTypeInitValue as 'store' | 'private') || 'store');
  const [deliveryStore, setDeliveryStore] = useState(_deliveryStore || '');
  const [deliveryStoreList, setDeliveryStoreList] = useState<{ value: string, label: string }[]>([]);
  const deliveryInfo = useMemo(() => {
    return currentData?.meta.deliveryData ?? {};
  }, [currentData]);
  const handlerClickFormDesignation = useCallback(() => {
    dispatch(printOrderLockActions.check(
      kijshopCd, shopOrderId, {
        yes: () => {
          dispatch(dialogActions.push({
            title: '発送帳票を選択',
            element: <PrintSelectFormDesignation
              kijshopCd={kijshopCd}
              shopOrderId={shopOrderId}
              callback={(res) => {
                dispatch(printActions.shopOrder({
                  kijshopCd, shopOrderId
                }).item().delivery({
                  shopCode: deliveryInfo.shopCode,
                  type: deliveryInfo.type,
                  ...res,
                }))
              }}
            />,
          }));
        },
        no: () => {
          dispatch(printOrderLockActions.setId(''));
          dispatch(push(RoutingPath.cnv.print({ kijshopCd })));
        },
      },
    ));
  }, [
    dispatch,
    kijshopCd,
    shopOrderId,
    deliveryInfo,
  ]);
  
  // -- 配送情報登録 --
  const handlerClickDeliveryStoreRegister = useCallback(() => {
    dispatch(dialogActions.push({
      title: '配送先情報入力',
      element: <DeliveryAddressInfoInput
        kijshopCd={kijshopCd}
        shopOrderId={shopOrderId}
        deliveryInfo={deliveryInfo}
        callback={(res) => {
          dispatch(printActions.shopOrder({
            kijshopCd, shopOrderId
          }).item().delivery({
            shopCode: deliveryInfo.shopCode,
            type: deliveryInfo.type,
            ...res,
          }))
        }}

      />,
    }));
  }, [kijshopCd, shopOrderId, deliveryInfo]);
  useEffect(() => {
    if (deliveryType === 'store') {
      // 代理発注の時
      if (currentData?.meta.info?.proxyMode) {
        setDeliveryStoreList([
          { 
            value: currentData.meta.deliveryData?.shopCode || '',
            label: currentData.meta.deliveryData?.shopCode || '',
          },
        ]);
        setDeliveryStore(currentData.meta.deliveryData?.shopCode ?? '');
      } else {
        if (masterShopList) {
          const shopList: { value: string, label: string }[] = masterShopList.map((v) => ({
            value: v.$.shopCode!,
            label: v.name?.[0].$.lastName!,
          })) || [];
          setDeliveryStoreList(shopList);
          const deliStore = (masterShopIdList.find((v) => v === _deliveryStore)) ? _deliveryStore
                  : (masterShopIdList.find((v) => v === kijshopCd)) ? kijshopCd : masterShopIdList[0];
          setDeliveryStore(deliStore);
        }
      }
      // set
    }
  }, [
    masterShopList,
    masterShopIdList,
    currentData,
  ]);

  const changeDeliveryType = useCallback((type: 'store' | 'private') => {
    if (type !== deliveryType) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          '配送方法を変更した場合、今まで入力した配送情報は初期化されます。',
          'よろしいですか？',
        ],
        buttons: [
          {
            label: 'いいえ',
            callback: () => {
              dispatch(dialogActions.pop());
              dispatch(dialogActions.pop());
              // TODO なぜか2回発動するので要修正
            },
          },
          {
            label: 'はい',
            callback: () => {
              dispatch(dialogActions.pop());
              dispatch(dialogActions.pop());
              setDeliveryType(type);
              const data: PrintDeliveryDataEntity = type === 'store' ? {
                type: 'shop',
                shopCode: currentData?.meta.info?.proxyMode
                  ? shopOrderId.slice(0, 7)
                  : deliveryStore,
              } : {
                type: 'customer',
                shopCode: currentData?.meta.info?.proxyMode
                  ? shopOrderId.slice(0, 7)
                  : kijshopCd,
              }
              dispatch(localStorageActions.setData(kijshopCd, 'deliveryType', type));
              dispatch(printActions.shopOrder({kijshopCd, shopOrderId}).item().delivery(
                data,
              ));
            },
          },
        ],
      }));
    }
  }, [
    dispatch,
    kijshopCd,
    shopOrderId,
    deliveryStore,
    deliveryType,
    currentData?.meta.info?.proxyMode
  ]);

  const handlerChangeDeliveryStore = useCallback((v: string) => {
    // dispatch(orderLockActions.check(
    //   kijshopCd, shopOrderId,
    //   {
    //     yes: () => {
          const data = cloneDeep(currentData);
          if (data?.meta) {
            data.meta.deliveryData = {
              ...data.meta.deliveryData,
              shopCode: v,
            }
            setDeliveryStore(v);
            dispatch(printActions.shopOrder({kijshopCd, shopOrderId}).item().delivery(
              data.meta.deliveryData,
            ));
            dispatch(localStorageActions.setData(kijshopCd, 'deliveryStore', v));
          }
          // }
    //     },
    //     no: () => {
    //       dispatch(orderLockActions.setId(''));
    //       dispatch(push(RoutingPath.cnv.orders({ kijshopCd })));
    //     },
    //   },
    // ));
  }, [
    kijshopCd, shopOrderId,
    currentData, dispatch,
  ]);

  useEffect(() => {
    const deliveryData = currentData?.meta.deliveryData
    if (deliveryData) {
      setDeliveryType(deliveryData.type === 'customer' ? 'private' : 'store');
      if (deliveryData.type === 'customer') {
        setDeliveryStore(kijshopCd);
      } else {
        const shopList = masterShopList?.map((v) => ({
          value: v.$.shopCode!,
          label: v.name?.[0].$.lastName!,
        })) || [];
        const target = shopList.find(v => v.value === deliveryData.shopCode);
        if (target) {
          setDeliveryStore(target.value);
        }
      }
    }
  }, [currentData, masterShopList]);
  

  return {
    deliveryType,
    deliveryStoreList,
    deliveryStore,
    changeDeliveryType,
    handlerClickDeliveryStoreRegister,
    handlerClickFormDesignation,
    handlerChangeDeliveryStore,
  }    
}